<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { reactive, ref } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import KTextField from '@/components/fields/KTextField.vue';
import useForm from '@/composables/useForm';
import {
  nonZeroPositiveDecimalRequiredValidationRule,
  requiredValidationRule,
} from '@/helpers/validationRules';

export interface InitialData {
  model?: string;
  volume?: number;
  weight?: number;
}

export interface ValidData {
  model: string;
  volume: number;
  weight: number;
}

export interface Props {
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  if (formData.model == null) return;
  if (formData.volume == null) return;
  if (formData.weight == null) return;
  // TODO could be either number or string here
  // TODO maybe share this logic with validation rules
  const volume = Math.abs(parseFloat(formData.volume.toString()));
  const weight = Math.abs(parseFloat(formData.weight.toString()));
  if (!volume) return;
  if (!weight) return;
  const validData: ValidData = {
    model: formData.model,
    volume: formData.volume,
    weight: formData.weight,
  };
  emit('submit', event, validData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.newAirRoadAddExtraProductForm"
    data-testid="newAirRoadAddExtraProductForm"
    @submit.prevent="handleSubmit"
  >
    <KTextField
      v-model="formData.model"
      size="sm"
      label="Model"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <div :class="$style.fieldGroup">
      <div :class="$style.groupItem">
        <KTextField
          v-model="formData.volume"
          size="sm"
          label="Volume (m³)"
          :rules="[nonZeroPositiveDecimalRequiredValidationRule]"
          :class="$style.field"
          class="mr-2"
          disabled
        />
      </div>
      <div :class="$style.groupItem">
        <KTextField
          v-model="formData.weight"
          size="sm"
          label="Weight (kg)"
          :rules="[nonZeroPositiveDecimalRequiredValidationRule]"
          :class="$style.field"
        />
      </div>
    </div>
    <div class="text-right">
      <KBtn
        type="submit"
        prepend-icon="mdi-arrow-up-bold-circle-outline"
        :class="$style.submit"
        size="sm"
        priority="info"
        variant="outlined"
      >
        Add a product
      </KBtn>
    </div>
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadAddExtraProductForm {
  line-height: 1.4;
}
  .field {
    margin-bottom: 10px;
  }
  .fieldGroup {
    display: flex;
  }
    .groupItem {
      width: 50%;
    }
  .submit {
  }
</style>
